import { createSelector } from 'reselect';

import { initialState } from './reducers';

const selectState = (state) => state.get('donationsPage') || initialState;

export const selectFetchParams = createSelector(selectState, (state) => state.get('fetchParams'));

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectSort = createSelector(selectState, (state) =>
  state.get('fetchParams').get('sort')
);

export const selectOrder = createSelector(selectState, (state) =>
  state.get('fetchParams').get('order')
);

export const selectSearch = createSelector(selectState, (state) =>
  state.get('fetchParams').get('search')
);

export const selectError = createSelector(selectState, (state) => state.get('error'));

export const selectSelectedDonations = createSelector(selectState, (state) =>
  state.get('selectedDonations')
);

export const selectIsOverviewOpen = createSelector(selectState, (state) =>
  state.get('isOverviewOpen')
);

export const selectInitialized = createSelector(selectState, (state) => state.get('initialized'));
